module.exports = __webpack_public_path__ + "cr.svg?241eea715bd6ab7a8ab41ec1edb22c72";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cr.svg
// module id = 976
// module chunks = 27